
import { defineComponent, PropType, provide } from 'vue';
import { useVModel } from 'vue-composable';
import { useStore } from '@/store';
import { Truck } from '@/types/app';
import { InjectionKeys } from '@/constants';
import AppModal from '@/components/modal/base/AppModal.vue';

export default defineComponent({
  name: 'TruckDeleteFormModal',
  emits: ['update:openState'],
  components: {
    AppModal
  },
  props: {
    openState: {
      type: Boolean,
      required: true
    },
    truck: {
      type: Object as PropType<Truck>
    }
  },
  setup(props) {
    const isOpen = useVModel(props, 'openState');

    const store = useStore();
    const submit = async () => props.truck && store.dispatch.trucks.delete(props.truck);

    provide(InjectionKeys.FormSubmit, submit);

    return {
      isOpen
    };
  }
});
